module.exports = __webpack_public_path__ + "static/media/logo_mecenazgo.9b6f7ad6.png";